// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // LOCAL DEV
  // apiUrl: 'http://localhost:50787/api'

  // HOSTING SERVER
  // apiUrl: 'http://37.59.54.115:8084/api'

  // DEMO1
  apiUrl: 'https://transformdemoapi.glantus.com/api'

  // TEST1
  // apiUrl: 'http://212.126.35.233:8081/api'

  // LOCAL IIS
  // apiUrl: 'http://localhost:8084/api'
};
